module.exports = __webpack_public_path__ + "static/media/kaikuutamo.6c3652ff.jpg";